module.exports = __webpack_public_path__ + "static/media/Montana2925.dce6ba09.jpg";